




























































import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import { FormatStructureEditableMixin } from "../../mixins";

interface IWritingLimit {
  section: string;
  target: string;
}

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class FormatPropertyLimitWritingLimitsEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  // TODO FormatStructureEditableMixin、FormatStructureEditor、IEditableFormatStructureに移動する
  enabled: boolean = false;
  limitDate: string = "";
  limitHour: string = "";
  limitMinutes: string = "";
  writingLimitsType: string = "0";
  writingLimitsTypeOptions: StandardOption<string>[] = [
    new StandardOption<string>("全文書", "0"),
    new StandardOption<string>("全ユーザ記載不可", "1"),
    new StandardOption<string>("記載可能条件あり", "2"),
  ];
  writingLimits: IWritingLimit[] = [
    { section: "ユーザ", target: "クライオ管理者" },
    { section: "記載者", target: "記載者ユーザ" },
    { section: "所属診療科", target: "記載者の所属診療科" },
  ];
  selectedWritingLimit: IWritingLimit = null;

  get hasSelectedLimit(): boolean {
    return !!this.selectedWritingLimit;
  }

  openDialog(): void {
    this.$notImplemented();
  }

  removeSelectedLimit(): void {
    this.$notImplemented();
  }

  async handleSelectionChanged(row: IWritingLimit): Promise<void> {
    this.selectedWritingLimit = row;
  }
}
